
import { makeStyles } from '@mui/styles';

const styles = (theme) => ({

    container: () => {
      return  {
          display: 'flex',
          height: '100vh',
          width: '100%',

          flexDirection: 'column !important',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'scroll',
      };
    },

    body: () => {
      return  {
        display: 'flex',
        width: '100%',
        padding: '0 48px',
        flexDirection: 'column !important',
        justifyContent: 'center',
        alignItems: 'center',
      };
    },

    subtitle: () => {
      return  {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '20px',
      };
    },

    bodyMessages: () => {
      return  {
        display: 'flex',
        flexDirection: 'column !important',
        fontSize: '14px',
        width: '100%',
        fontWeight: 'regular',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '24px 0px',
        textAlign: 'center',
      };
    },
 
    buttonPanel: () => {
      return  {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      };
    },


    copyLinkIcon: {
      backgroundColor: '#000082',
    },

    copyButtonOutlined: (p) => {
      const {
        commonUIStyles = {
          copyLinkButton: () => ({}),
        },
      } = p;
      const copyLinkStyles = commonUIStyles.copyLinkButton();
      const styles = {
        backgroundColor: 'transparent !important',
        border: 'none !important',
        color: '#000082 !important',
        fontWeight: '400',
        boxShadow: 'none',
      };

      return  {
        '&.MuiButton-root': {
          ...copyLinkStyles,
          ...styles,
          '&[disabled]': {
            ...styles,
          },
        },
      };
    },

    copyButtonSolid: (p) => {
      const {
        commonUIStyles = {
          copyLinkButton: () => ({}),
        },
      } = p;
      const copyLinkStyles = commonUIStyles.copyLinkButton();
      const styles = {
        backgroundColor: '#000082 !important',
        color: '#FFFFFF !important',
        border: 'none',
        borderRadius: '0 !important',
        height: '100%',
        fontWeight: 'bold !important',
      };

      return  {
        '&.MuiButton-root': {
          ...copyLinkStyles,
          ...styles,
          '&[disabled]': {
            ...styles,
          },
        },
      };
    },

    linkSpace: {
      display: 'flex',
      width: 'calc(100% - 32px)',
      height: '52px',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '24px',
      border: '1px solid #DEDDDF',
      borderRadius: '8px',
      overflow: 'hidden',
      padding: '0px 0px 0px 10px',
      boxSizing: 'border-box',
    },

    linkDivider: {
      width: '1px',
      alignSelf: 'stretch',
      backgroundColor: '#DEDDDF',
      flexShrink: 0,
    },

    webcalPrefix: {
      fontFamily: 'monospace',
      fontSize: '11px',
      fontWeight: 600,
      color: '#1a48b8',
      backgroundColor: '#e8f0fe',
      padding: '2px 4px',
      borderRadius: '3px',
      flexShrink: 0,
      lineHeight: '1.5',
      marginRight: '2px',
    },

    link: ({ commonUIStyles }) => {
      return {
        ...commonUIStyles.textLink(),
        color: '#1a1a1a',
        fontSize: '11px',
        fontWeight: 400,
        lineHeight: '1.5',
        display: 'block',
        flex: 1,
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        textTransform: 'none',
      };
    },

    copyButtonBase: {
      '&.MuiButtonBase-root': {
        whiteSpace: 'nowrap',
        flex: '0 0 auto',
        height: '100%',
        padding: '0 8px',
        borderRadius: 0,
      }
    },


    help: {
      marginTop: '24px',
      marginBottom: '52px',
      display: 'flex',
      flexDirection: 'row',
      width: 'calc(100% - 64px)',
      justifyContent: 'center',
    },
});

export default styles;
export const useStyles = makeStyles(styles);
